import memoize from 'lodash/memoize';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { TunerVars } from '../../../utils/index';
import * as D from '../deps';

import BackstageAlbum from './BackstageAlbum';
import BackstageArtist from './BackstageArtist';
import BackstageTrack from './BackstageTrack';
import BackstageArtist2 from './pages/BackstageArtist2/BackstageArtist';
import BackstageCurator from './pages/BackstageCurator/BackstageCuratorDataFetcher';

const memoizeParams = memoize(
  props => {
    const path = props.location.pathname;
    const { seoToken1, seoToken2, seoToken3, seoToken4, pandoraId } = props.params;
    const isCuratorPath =
      D.Utils.Route.isBackstageCuratorPath(path) || D.Utils.Route.isBackstageCuratorChildPath(path);
    const params = isCuratorPath ? {} : { artistSeoToken: seoToken1 };

    if (D.Utils.Route.isBackstageArtistPath(path)) {
      params.pandoraId = seoToken2;
    } else if (D.Utils.Route.isBackstageAlbumPath(path)) {
      params.albumSeoToken = seoToken2;
      params.pandoraId = seoToken3;
    } else if (D.Utils.Route.isBackstageTrackPath(path)) {
      params.albumSeoToken = seoToken2;
      params.trackSeoToken = seoToken3;
      params.pandoraId = seoToken4;
    } else if (D.Utils.Route.isBackstageArtistChildPagePath(path)) {
      params.pandoraId = pandoraId;
    } else if (D.Utils.Route.isBackstageAlbumChildPagePath(path)) {
      params.pandoraId = pandoraId;
    } else if (D.Utils.Route.isBackstageTrackChildPagePath(path)) {
      params.albumSeoToken = seoToken2;
      params.trackSeoToken = seoToken3;
      params.pandoraId = pandoraId;
    } else if (isCuratorPath) {
      params.pandoraId = pandoraId;
    }
    return params;
  },
  props => props.location.pathname,
);

export class Backstage extends React.Component {
  static propTypes = {
    // These params properties are tokens coming from urls matched and parsed by react-router
    // and they are positional, thus their names. We only determine their purpose after this
    // component is instantiated.
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
    params: PropTypes.shape({
      seoToken1: PropTypes.string,
      seoToken2: PropTypes.string,
      seoToken3: PropTypes.string,
      seoToken4: PropTypes.string,
      pandoraId: PropTypes.string,
    }).isRequired,
    children: PropTypes.element,
    isCuratorExperienceEnabled: PropTypes.bool,
  };

  render() {
    const path = this.props.location.pathname;
    const params = memoizeParams(this.props);
    if (D.Utils.Route.isBackstageArtistPath(path)) {
      return this.props.isCuratorExperienceEnabled ? (
        <BackstageArtist2 params={params} />
      ) : (
        <BackstageArtist params={params} />
      );
    } else if (D.Utils.Route.isBackstageAlbumPath(path)) {
      return <BackstageAlbum params={params} />;
    } else if (D.Utils.Route.isBackstageTrackPath(path)) {
      return <BackstageTrack params={params} />;
    } else if (D.Utils.Route.isBackstageArtistChildPagePath(path)) {
      return this.props.isCuratorExperienceEnabled ? (
        <BackstageArtist2 params={params}>{this.props.children}</BackstageArtist2>
      ) : (
        <BackstageArtist params={params}>{this.props.children}</BackstageArtist>
      );
    } else if (D.Utils.Route.isBackstageAlbumChildPagePath(path)) {
      return <BackstageAlbum params={params}>{this.props.children}</BackstageAlbum>;
    } else if (D.Utils.Route.isBackstageTrackChildPagePath(path)) {
      return <BackstageTrack params={params}>{this.props.children}</BackstageTrack>;
    } else if (D.Utils.Route.isBackstageCuratorPath(path)) {
      return <BackstageCurator params={params} />;
    } else if (D.Utils.Route.isBackstageCuratorChildPath(path)) {
      return <BackstageCurator params={params}>{this.props.children}</BackstageCurator>;
    }
  }
}

export function mapStateToProps(state) {
  return { isCuratorExperienceEnabled: TunerVars.curatorExperienceEnabled(state) };
}

export default connect(mapStateToProps)(Backstage);
